export const useDownloadFile = (file: string | Blob, fileName: string) => {
  const downloadUrl =
    file instanceof Blob ? window.URL.createObjectURL(new Blob([file])) : file;
  const link = document.createElement("a");
  link.href = downloadUrl as string;
  link.setAttribute("download", fileName);
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
